module.exports = __webpack_public_path__ + "static/media/secure-stripe-payment-logo.8d9b26e9.png";